// @ts-nocheck
import { getCurrentPage } from "@insite/client-framework/Store/Data/Pages/PageSelectors";
import constants from "@store/constants";
import { addToChainAfter, createChainHandler } from "@toolkit/Modules/client-framework/HandlerCreator";
import {
    chain,
    PopulateApiParameter,
} from "@insite/client-framework/Store/Data/Orders/Handlers/LoadOrderByOrderNumber";

export const StorePopulateApiParameter = createChainHandler("PopulateApiParameter", chain, props => {
    const page = getCurrentPage(props.getState());
    if (page.type === constants.pageType.requestRma) {
        if (props.apiParameter.additionalExpands) {
            props.apiParameter.additionalExpands.push("requestReturnedOrdersQty");
        } else {
            props.apiParameter.additionalExpands = ["requestReturnedOrdersQty"];
        }
    }
});

addToChainAfter(chain, PopulateApiParameter, StorePopulateApiParameter);
